<template>
  <div class="page-content OnlineBooking">
    <h1 class="page-title">{{ $locale("sideMenu.onlineReservationSalesReport") }}</h1>

    <!-- Search Area -->
    <el-form :model="search" :rules="rules" ref="searchFormRef">
      <el-row :gutter="10" class="search-area">
        <el-col :span="6">
          <el-form-item prop="cinemaIds">
            <el-select
              v-model="search.cinemaIds"
              multiple
              clearable
            >
            <el-option
              disabled
              value="-1"
              class="disable"
            >
              <el-row class="select-handle" style="font-size: 16px;">
                <el-col :span="6">
                  <div @click="selectHandler('select')" class="action">
                    <a class="el-icon-check"></a>
                    {{ $locale("global.selectAll") }}
                  </div>
                </el-col>
                <el-col :span="6">
                  <div @click="selectHandler('empty')" class="action">
                    <a class="el-icon-close"></a>
                    {{ $locale("global.deselectAll") }}
                  </div>
                </el-col>
              </el-row>
            </el-option>
            <el-option
              v-for="item in cinemaList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
            </el-select>
            <!-- <RemoteSelectV2
              type="cinema"
              :list="comCinemaList"
              v-model="search.cinemaIds"
              :isMultiple="true"
              :isSelectAllFunc="true"
              @selectAll="arr => search.cinemaIds = arr"
              :formValue.sync="search.cinemaIds"
              @setList="arr => comCinemaList = arr"
              :fields="['id', 'name']"
            /> -->

          </el-form-item>
        </el-col>
        <el-col :span="14">
          <DatePickerGroup
            v-model="search.filterDateObj"
            :showWeekly="true"
            :startPickerOptions="datePickerOptions"
            :endPickerOptions="datePickerOptions"
          />
          <el-button class="egl-btn-yellow" @click="search_fn">{{ $locale("global.search") }}</el-button>
        </el-col>
        <el-col :span="4" class="ta-r">
            <el-button :disabled="tableData.length ? false : true" @click="downloadCsv" class="egl-btn-yellow">{{
            $locale("global.exportToCSV")
        }}</el-button>
        <el-button class="egl-btn-yellow" v-print="printObj">{{ $locale("global.printBtn") }}</el-button>
        </el-col>
    </el-row>
    <el-row>
      <el-col :span="16">
        <el-checkbox-group v-model="search.showRule">
          <el-checkbox label="withoutTransactions">{{$locale("trans.box.witchoutTransactions")}}</el-checkbox>
        </el-checkbox-group>
      </el-col>
    </el-row>
    </el-form>

    <!-- Table -->
    <div id="print">
      <div class="table-module">
        <div class="info-supplement-container">
          <el-row class="module-sms" :gutter="10">
            <el-col :span="3">{{ $locale("sideMenu.onlineReservationSalesReport") }}</el-col>
            <el-tooltip :disabled="!showToolTip" :content="tooltipContent" placement="top" style="width: 500px !important;">
              <el-col ref="textElement" :span="17" class="text-truncate">
                {{ tooltipContent }}
              </el-col>
            </el-tooltip>
            <el-col :span="4">{{ $locale('trans.report.generatedate') }}：{{ createTime }}</el-col>
          </el-row>
          <el-row class="module-sms" :gutter="10">
              <el-col :span="10"> 年月：{{ reportDateDisplay }} </el-col>
          </el-row>
        </div>
      </div>
      <div class="custom-border-table preSalesDailyDataTable">
        <el-table
          class="egl-table list-table"
          style="width: 100%"
          :data="tableData"
          :border="true"
          ref="onlineBookingTable"
          :span-method="objectSpanMethod"
        >
          <el-table-column :label="$locale('global.sort')" prop="sort"></el-table-column>
          <el-table-column :label="$locale('global.cinemaName')" prop="cinemaName" width="300"></el-table-column>
          <el-table-column :label="$locale('report.onlineReservation.online')" align="center">
            <el-table-column :label="$locale('operation.NAT.qty')" prop="commissionFees_visitor" width="80"></el-table-column>
            <el-table-column :label="$locale('accountPayable.income')" width="120">
              <template slot-scope="scope">
                {{ scope.row.commissionFees_total | currencyFormat }}
              </template>
            </el-table-column>
            <el-table-column :label="$locale('dailyDetail.seatNumber')" prop="commissionFees_seatVisitor" width="80"></el-table-column>
            <el-table-column :label="$locale('dailyDetail.seatSales')" width="180">
              <template slot-scope="scope">
                {{ scope.row.commissionFees_seatTotal | currencyFormat }}
              </template>
            </el-table-column>
            <el-table-column :label="$locale('report.onlineReservation.salesTotal')" width="180">
              <template slot-scope="scope">
                {{ scope.row.commissionFees_allTotal | currencyFormat }}
              </template>
            </el-table-column>
            <el-table-column :label="$locale('report.onlineReservation.systemUseFee(excluding tax)')" width="180">
              <template slot-scope="scope">
                {{ scope.row.commissionFees_allTotalFee | currencyFormat }}
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column :label="$locale('report.onlineReservation.PG')" align="center">
            <el-table-column :label="$locale('report.onlineReservation.salesProcessed')" align="center">
              <el-table-column :label="$locale('report.onlineReservation.transactionNumber')" prop="completedSales_allTotal" width="160"></el-table-column>
              <el-table-column :label="$locale('report.salesProcessed')" prop="completedSales_salesTotal" width="100"></el-table-column>
            </el-table-column>
            <el-table-column :label="$locale('report.onlineReservation.cancellationsProcessed')" align="center">
              <el-table-column :label="$locale('report.onlineReservation.transactionNumber')" prop="refundedSales_allTotal" width="160"></el-table-column>
              <el-table-column :label="$locale('report.salesProcessed')" prop="refundedSales_salesTotal" width="100"></el-table-column>
            </el-table-column>
            <el-table-column :label="$locale('report.allSales')" align="center">
              <el-table-column :label="$locale('report.allSales.allTotal')" prop="allSales_allTotal" width="180"></el-table-column>
              <el-table-column :label="$locale('report.allSales.salesTotal')" prop="allSales_salesTotal" width="200"></el-table-column>
              <el-table-column :label="$locale('report.allSales.allTotalFee')" prop="allSales_allTotalFee" width="220"></el-table-column>
              <el-table-column :label="$locale('report.allSales.salesTotalFee')" prop="allSales_salesTotalFee" width="180"></el-table-column>
            </el-table-column>
            <el-table-column :label="$locale('report.onlineReservation.processingTotal')" prop="total" width="100"></el-table-column>
          </el-table-column>
          <el-table-column :label="$locale('report.onlineReservation.card')" align="center">
            <el-table-column label="VISA/MASTER" width="140">
              <template slot-scope="scope">
                {{ scope.row.vmCardTotal | currencyFormat }}
              </template>
            </el-table-column>
            <el-table-column label="JCB/AMEX/Diners" width="180">
              <template slot-scope="scope">
                {{ scope.row.jadCardTotal | currencyFormat }}
              </template>
            </el-table-column>
            <el-table-column label="PayPay" width="140">
              <template slot-scope="scope">
                {{ scope.row.paypayTotal | currencyFormat }}
              </template>
            </el-table-column>
            <el-table-column label="クレジットカード決済手数料(税抜)" width="140" align="center">
              <el-table-column label="VISA/MASTER" width="140">
                <template slot-scope="scope">
                  {{ scope.row.vmCardTotalFee | currencyFormatter }}
                </template>
              </el-table-column>
              <el-table-column label="JCB/AMEX/Diners" width="180">
                <template slot-scope="scope">
                  {{ scope.row.jadCardTotalFee | currencyFormatter }}
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="PayPay決済手数料(税抜)" width="180">
              <template slot-scope="scope">
                {{ scope.row.paypayTotalFee | currencyFormatter }}
              </template>
            </el-table-column>
            <el-table-column :label="$locale('report.onlineReservation.totalAmount')" width="120">
              <template slot-scope="scope">
                {{ scope.row.cardTotal | currencyFormat }}
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column :label="$locale('report.onlineReservation.bookPerformance')" align="center" key="col-boxOffice" v-if="(isShowColumn || {}).isShowBoxOffice">
            <el-table-column :label="$locale('operation.NAT.qty')" prop="boxOffice_visitor" width="80"></el-table-column>
            <el-table-column :label="$locale('global.amount')" width="120">
              <template slot-scope="scope">
                {{ scope.row.boxOffice_total | currencyFormat }}
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column :label="$locale('report.onlineReservation.morningShow')" align="center" key="col-morningShow" v-if="(isShowColumn || {}).isShowMorning">
            <el-table-column :label="$locale('operation.NAT.qty')" prop="morningShow_visitor" width="80"></el-table-column>
            <el-table-column :label="$locale('global.amount')" width="120">
              <template slot-scope="scope">
                {{ scope.row.morningShow_total | currencyFormat }}
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column :label="$locale('report.onlineReservation.lateShow')" align="center" key="col-lateShow" v-if="(isShowColumn || {}).isShowLateShow">
            <el-table-column :label="$locale('operation.NAT.qty')" prop="lateShow_visitor" width="120"></el-table-column>
            <el-table-column :label="$locale('global.amount')" width="120">
              <template slot-scope="scope">
                {{ scope.row.lateShow_total | currencyFormat }}
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column :label="$locale('report.onlineReservation.allNight')" align="center" key="col-allNight" v-if="(isShowColumn || {}).isShowAllNight">
            <el-table-column :label="$locale('operation.NAT.qty')" prop="allNight_visitor" width="80"></el-table-column>
            <el-table-column :label="$locale('global.amount')" width="130">
              <template slot-scope="scope">
                {{ scope.row.allNight_total | currencyFormat }}
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column :label="$locale('report.onlineReservation.specialBusiness')" align="center" key="col-specialBusiness" v-if="(isShowColumn || {}).isShowSpecial">
            <el-table-column :label="$locale('operation.NAT.qty')" prop="specialBusiness_visitor" width="80"></el-table-column>
            <el-table-column :label="$locale('global.amount')" width="120">
              <template slot-scope="scope">
                {{ scope.row.specialBusiness_total | currencyFormat }}
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column :label="$locale('report.onlineReservation.total')" align="center" key="col-boxOfficelateShow">
            <el-table-column :label="$locale('operation.NAT.qty')" prop="boxOfficelateShow_visitorTotal" width="120"></el-table-column>
            <el-table-column :label="$locale('global.amount')" width="120">
              <template slot-scope="scope">
                {{ scope.row.boxOfficelateShow_total | currencyFormat }}
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column :label="$locale('report.onlineReservation.advanceTicket')" align="center" key="col-advanceTicket">
            <el-table-column :label="$locale('operation.NAT.qty')" prop="advanceTicket_visitor" width="120"></el-table-column>
            <el-table-column :label="$locale('global.amount')" width="120">
              <template slot-scope="scope">
                {{ scope.row.advanceTicket_total | currencyFormat }}
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column :label="$locale('report.onlineReservation.nationTicket')" width="160" key="col-nationTicket">
            <el-table-column :label="$locale('operation.NAT.qty')" prop="nationalTicket_visitor" width="120"></el-table-column>
            <el-table-column :label="$locale('global.amount')" width="100">
              <template slot-scope="scope">
                {{ scope.row.nationalTicket_total | currencyFormat }}
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column :label="$locale('report.onlineReservation.totalAmount')" width="120">
            <template slot-scope="scope">
                {{ scope.row.ticket_total | currencyFormat }}
              </template>
          </el-table-column>
          <el-table-column label="ネット仮押チケット" width="120" align="center" v-if="tableData.some(item => item.freeHoldSeatPayedCount > 0 || item.freeHoldSeatPendingCount > 0)">
            <el-table-column :min-width="180" label="支払前" prop="freeHoldSeatPendingCount" align="center"></el-table-column>
            <el-table-column :min-width="180" label="支払済み" prop="freeHoldSeatPayedCount" align="center"></el-table-column>
            <el-table-column :min-width="180" label="支払済み枚数" prop="freeHoldSeatPayedFee" align="center"></el-table-column>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import RemoteSelectV2 from "@/components/common/RemoteSelect-v2";
import DatePickerGroup from "@/components/common/CommDatePickerGroup/DatePickerGroup";

import { getCinemaListMap } from "@/helpers/service/api/common";

import {
  saveSearchParams, searchParamsCache, displayMultiCinemaNames, formatReportDate, formatResponseData
} from "@/utils/onlineReservationSalesReport.js";
import CheckOverflowMixin from "@/mixins/CheckOverflowMixin.js";
import { getOnlineReservationSalesReportService } from "@/helpers/service/api/onlineBooking";
import { toThousands } from "../../utils/common";
import { exportCSV_fn } from "@/assets/js/onlineReservationSalesReport_exportCSV.js";
import { currencyFormatter } from "@/utils/filters";

export default {
  mixins: [ CheckOverflowMixin ],
  data() {
    return {
      search: {
        cinemaIds: [],
        showRule: [ "withoutTransactions" ],
        filterDateObj: {
          startDate: this.$moment().startOf("day").valueOf(),
          endDate: this.$moment().startOf("day").valueOf(),
        },
      },
      cinemaList: [],
      datePickerOptions: {
        disabledDate: this.dateDisableDate,
      },
      createTime: "",
      tableData: [],
      originData: {},
      printObj: {
        popTitle: this.$locale("sideMenu.onlineReservationSalesReport"),
        id: "print"
      },
      reportDateDisplay: "",
      rules: {
        cinemaIds: [
          {
            required: true,
            message: this.$locale("global.cinemaName") + this.$locale("form.plsSelect"),
            trigger: "change",
          },
        ],
      },
    };
  },
  computed: {
    tooltipContent() {
      return this.$locale("global.cinemaName") + ": " + displayMultiCinemaNames(this.search.cinemaIds, this.cinemaList);
    },
    isShowColumn() {
      if (!this.$_.has(this.originData, 'records')) return {};
      const data =  this.originData.records.map(item => ({
        allTotal: item.allTotal,
      }));
      const isShowBoxOffice = data.some(item => this.$_.has(item.allTotal, 'boxOffice'));
      const isShowMorning = data.some(item => this.$_.has(item.allTotal, 'morningShow'));
      const isShowLateShow = data.some(item => this.$_.has(item.allTotal, 'lateShow'));
      const isShowAllNight = data.some(item => this.$_.has(item.allTotal, 'allNight'));
      const isShowSpecial = data.some(item => this.$_.has(item.allTotal, 'special'));

      return {
        isShowBoxOffice,
        isShowMorning,
        isShowLateShow,
        isShowAllNight,
        isShowSpecial,
      }
    }
  },
  filters: {
    currencyFormat(value) {
      return value !== null && value !== undefined ? "¥" + toThousands(value) : "";
    },
  },
  watch: {
    // 监视tooltipContent，当它变化时重新检查
    tooltipContent() {
      this.checkOverflow();
    },
  },
  created() {
    this.fetchDataAndSetSearchParams();
  },
  mounted() {
    this.$nextTick(() => {
      this.checkOverflow();
    });
  },

  methods: {
    // 异步设置userSettingSearchCache
    async fetchDataAndSetSearchParams() {
      try {
        
        const res = await getCinemaListMap({
          status: "active",
          page: 0,
          pageSize: 99999,
          field: ['id', 'name'],
        }, false);
        
        this.cinemaList = res.data.data;
        // let targetRes
        // if (searchParamsCache) {
        //   targetRes = await getCinemaListMap({
        //     status: "active",
        //     ids: searchParamsCache.cinemaIds,
        //     page: 0,
        //     pageSize: 99999
        //   }, false)
        // }
        // this.comCinemaList = this.$_.uniqBy([
        //   ...(targetRes && targetRes.data && targetRes.data.data ? [...targetRes.data.data] : []),
        //   ...res.data.data.map(item => ({
        //     id: item.id,
        //     name: item.name,
        //   })),
        // ], 'id');

        if (searchParamsCache) {
          this.search = searchParamsCache;
        }
      } catch (error) {
        console.error(error);
      }
    },
    dateDisableDate(time) {
      return time.getTime() > this.$moment().valueOf();
    },
    search_fn() {
      this.$refs.searchFormRef.validate(valid => {
        if (valid) {
          // api
          saveSearchParams(this.search);
          const {
            cinemaIds,
            filterDateObj,
          } = this.search;
          getOnlineReservationSalesReportService({
            cinemaIds,
            startDate: this.$moment(filterDateObj.startDate).format("YYYY-MM-DD"),
            endDate: this.$moment(filterDateObj.endDate).format("YYYY-MM-DD"),
          }).then(res => {
            this.createTime = this.$moment(res.data.exportAt).format("YYYY-MM-DD HH:mm:ss");
            this.reportDateDisplay = formatReportDate(this.$moment(res.data.reportStart).format("YYYY-MM-DD"), this.$moment(res.data.reportEnd).format("YYYY-MM-DD"));
            // format response data
            if (res.data && res.data.records && res.data.records.length > 0) {
              this.originData = res.data;
              console.log("555", formatResponseData(res.data.records, res.data.grandTotal));
              this.tableData = formatResponseData(res.data.records, res.data.grandTotal);
            } else {
              this.originData = {};
              this.tableData = [];
            }
          });
        }
      });
    },
    downloadCsv() {
      exportCSV_fn(this.tableData, this.search.filterDateObj.startDate, this.search.filterDateObj.endDate);
    },
    objectSpanMethod({ row, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (row.sort === "") {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
      if (columnIndex === 1) {
        if (row.sort === "") {
          return {
            rowspan: 1,
            colspan: 2,
          };
        }
      }
    },
    // 全选/反选cinema
    selectHandler(act) {
      this.search.cinemaIds = act === 'select' ? this.cinemaList.map((item) => item.id) : [];
    },
  },
  components: {
    RemoteSelectV2,
    DatePickerGroup
  },
};
</script>
<style lang="scss" scoped>
.text-truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.el-tooltip__popper {
  max-width: 500px; /* 限制tooltip的最大宽度 */
}
.disable {
  cursor: pointer !important;
}
.action:hover {
  font-weight: 600;
  color: #F9B749;
  a {
    color: #F9B749;
  }
}
</style>